import React from 'react';
import { Typography, Grid, Paper, List, ListItem, ListItemText } from '@material-ui/core';
import Gallery from 'react-grid-gallery';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';

//services
import LojaAPI from '../../../services/api/Loja';

//css
import './lojas.css';

//svg
import FacebookIcon from '../../../images/svg/facebook_profile.svg';
import InstagramIcon from '../../../images/svg/instagram_profile.svg';

//utils
import { formatTel } from '../../../utils/format';



export default class VerLoja extends React.Component {
	state = {
		nome: undefined,
		piso: null,
		loja: null,
		email: null,
		site: null,
		facebook: null,
		telefone: null,
		instagram: null,
		descricao: null,
		logo: null,
		background: null,
		fotos:[],

		loading: true,
	}

	refreshLojas = () => {
		const { id } = this.props.match.params;
		const { history } = this.props;
		LojaAPI.get_web(id)
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					history.push('/404');
					return;
				}
				this.setState({
					nome: res.nome,
					piso: res.piso,
					loja: res.loja,
					email: res.email,
					site: res.site,
					facebook: res.facebook,
					telefone: res.telefone,
					instagram: res.instagram,
					descricao: res.descricao,
					logo: res.url,
					background: res.fotos.length > 0 ? res.fotos[0].url : null,
					fotos: res.fotos,
					loading:false,
				 })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshLojas()
	}

	render() {
		const { nome, piso, loja, email, site, facebook, instagram, descricao, logo, background, fotos, telefone, loading } = this.state;
		const { PUBLIC_URL } = process.env;
		const { pathname } = this.props.location;
		if( loading === true ){ return <LoadBox height="100vh"  /> }
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>{`${nome} - Lojas`}</title>
						<meta name="description" content={`${descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />

						<meta property="og:locale" content="pt_BR" />
						<meta property="og:url" content={`${PUBLIC_URL}${pathname}`} />
						<meta property="og:title" content={nome} />
						<meta property="og:site_name" content="Shopping Norte Sul" />
						<meta property="og:description" content={`${descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />
						<meta property="og:image" content={logo} />
						<meta property="og:type" content="website" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Loja</Typography>
						</div>
					</div>
					<div className="app_content_page_background" >
						<div className="app_content_page_background__overlay" ></div>
						{background === null ? <div style={{height:'100vh', backgroundColor: "#F1F1F1"}} ></div> : <img src={background} alt="Background" />}
					</div>
					<div className="app_content_page__row" >
						<div className="content_view_loja" >
							<Grid container spacing={32} >
								<Grid item md={4} xs={12} >
									<Paper elevation={1} className="paper_column_loja" >
										<div className="paper_column_loja__logo" >
											<img src={logo} alt={nome} />
										</div>
										<List>
											<ListItem>
												<ListItemText primary="TELEFONE" secondary={formatTel(String(telefone))} />
											</ListItem>
											<ListItem>
												<ListItemText primary="EMAIL" secondary={email} />
											</ListItem>
											<ListItem>
												<ListItemText primary="SITE" secondary={<a target="_BLANK" href={site} >{site}</a>} />
											</ListItem>
											<ListItem>
												<ListItemText primary="REDES SOCIAIS"/>
											</ListItem>
										</List>
										<div className="list_redes_sociais" >
											{facebook && <div className="list_redes_sociais__item" >
												<div className="icon" >
													<img src={FacebookIcon} alt="" />
												</div>
												<div className="text" ><a _target="_BLANK" href={`https://facebook.com/${facebook}`} >@{facebook}</a></div>
											</div>}
											{instagram && <div className="list_redes_sociais__item" >
												<div className="icon" >
													<img src={InstagramIcon} alt="" />
												</div>
												<div className="text" ><a _target="_BLANK" href={`https://instagram.com/${instagram}`} >@{instagram}</a></div>
											</div>}
										</div>
									</Paper>
								</Grid>
								<Grid item md={8} xs={12} >
									<Grid container spacing={16} >
										<Grid item xs={12} >
											<div className="title_loja" >
												<Typography variant="h5" >{nome}</Typography>
												<Typography variant="h6">{piso}º Piso - Loja {loja}</Typography>
											</div>
										</Grid>
										<Grid item xs={12} >
											<Typography variant="h5" >Descrição</Typography>
											{descricao !== null ? <div dangerouslySetInnerHTML={{__html: descricao}} ></div> : <div style={{ padding:'20px 0px 20px 0px' }} >Sem descrição!</div>}
										</Grid>
										<Grid item xs={12} >
											<Typography variant="h5" >Fotos</Typography>
											<div className="gallery_loja" >
												<Gallery backdropClosesModal={true}
														 enableImageSelection={false}
														 images={ConvertGallery(fotos)}/>
											</div>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</div>
					</div>
				</div>
        );
    }
}


function ConvertGallery(fotos){
	let rs = [];
	for( let f of fotos ){
		let a = {
			src: f.url,
			thumbnail: f.url,
			thumbnailWidth: 174,
			thumbnailHeight: 174,
		}
		rs.push(a)
	}
	return rs;
}



// WEBPACK FOOTER //
// ./src/web/pages/lojas/ver.js